import { baseURL } from "../utilits/config";
import axios from "axios";

export function getProductsAll(callback) {
  const config = {
    method: "get",
    url: baseURL + "/add-Products",
    headers: {},
  };

  axios(config)
    .then((result) => {
      callback(result.data);
    })
    .catch((error) => {
      callback(error);
    });
}

export function addProducts(productData, callback) {
  const config = {
    method: "post",
    url: baseURL + "/add-Products",
    headers: {
      "Content-Type": "application/json",
    },
    data: productData,
  };
  axios(config)
    .then((result) => {
      callback(result.data);
    })
    .catch((error) => {
      callback(error);
    });
}

export function getProductByProductID(productID, callback) {
  const config = {
    method: "get",
    url: baseURL + "/get-product-by-id?productID=" + productID,
    headers: {},
  };

  axios(config)
    .then((result) => {
      callback(result.data);
    })
    .catch((error) => {
      callback(error);
    });
}

export function getProductByProductIdAndFamer(productID, callback) {
  const config = {
    method: "get",
    url: baseURL + "/get-trader-stock?productID=" + productID,
    headers: {},
  };

  axios(config)
    .then((result) => {
      callback(result.data);
    })
    .catch((error) => {
      callback(error);
    });
}

export function getAllOrder(callback) {
  const config = {
    method: "get",
    url: baseURL + "/get-orders",
    headers: {},
  };

  axios(config)
    .then((result) => {
      callback(result.data);
    })
    .catch((error) => {
      callback(error);
    });
}

export function getAllOrderLeatest(callback) {
  const config = {
    method: "get",
    url: baseURL + "/get-orders-leatest",
    headers: {},
  };

  axios(config)
    .then((result) => {
      callback(result.data);
    })
    .catch((error) => {
      callback(error);
    });
}

export function getOrderByStatus(status, callback) {
  const config = {
    method: "get",
    url: baseURL + "/get-order-by-status?status=" + status,
    headers: {},
  };

  axios(config)
    .then((result) => {
      callback(result.data);
    })
    .catch((error) => {
      callback(error);
    });
}

export function updateSTock(stockData, callback) {
  const config = {
    method: "post",
    url: baseURL + "/update-stock",
    headers: {
      "Content-Type": "application/json",
    },
    data: stockData,
  };
  axios(config)
    .then((result) => {
      callback(result.data);
    })
    .catch((error) => {
      callback(error);
    });
}
